var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlusCircled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0.5 C22.5563492,0.5 26.6813492,2.34682541 29.6672619,5.33273811 C32.6531746,8.31865081 34.5,12.4436508 34.5,17 L34.5,17 L34.5,18 C34.5,22.5563492 32.6531746,26.6813492 29.6672619,29.6672619 C26.6813492,32.6531746 22.5563492,34.5 18,34.5 L18,34.5 L17,34.5 C12.4436508,34.5 8.31865081,32.6531746 5.33273811,29.6672619 C2.34682541,26.6813492 0.5,22.5563492 0.5,18 L0.5,18 L0.5,17 C0.5,12.4436508 2.34682541,8.31865081 5.33273811,5.33273811 C8.31865081,2.34682541 12.4436508,0.5 17,0.5 L17,0.5 Z",
    id: "Rectangle",
    stroke: "#0084F8",
    fill: "#FFFFFF",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.000000, 11.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy",
    transform: "translate(7.000000, 7.000000) rotate(-270.000000) translate(-7.000000, -7.000000) ",
    x: 0,
    y: 6,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy-2",
    transform: "translate(7.000000, 7.000000) rotate(-180.000000) translate(-7.000000, -7.000000) ",
    x: 0,
    y: 6,
    width: 14,
    height: 2
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlusCircled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plusCircled.c63a2c92.svg";
export { ForwardRef as ReactComponent };